
import { Component, Vue } from 'vue-property-decorator'
const ProductCatalog = () => import('../components/ProductCatalog.vue')

@Component({
  components: { ProductCatalog }
})
export default class Home extends Vue {
  data() {
    return {
      items: [
        {
          src: 'https://schooloutfitters-images.azureedge.net/fdp/carousel_1.jpg'
        },
        {
          src: 'https://schooloutfitters-images.azureedge.net/fdp/carousel_2.jpg'
        },
        {
          src: 'https://schooloutfitters-images.azureedge.net/fdp/carousel_3.jpg'
        },
        {
          src: 'https://schooloutfitters-images.azureedge.net/fdp/carousel_4.jpg'
        }
      ]
    }
  }
}
